"use strict";

exports.__esModule = true;
exports.createRootElement = exports["default"] = createRootElement;

/**
functions that update the DOM
separated out so we can mock them during testing
otherwise testing craps out
*/
function createRootElement() {
  var modalRootElem = document.getElementById('st-modal-root');

  if (!modalRootElem) {
    modalRootElem = document.createElement('div');
    modalRootElem.setAttribute('id', 'st-modal-root');
    modalRootElem.classList.add('st_modal-root');
    document.body.appendChild(modalRootElem);
  }

  return modalRootElem;
}